// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "rec-" + chunkId + "." + {"34":"d09e0230","324":"38962622","548":"a9f53dbc","606":"918c1115","650":"cf01dcc1","672":"96fa2179","686":"4902aa74","907":"3245d2b9","978":"02b83082"}[chunkId] + ".js";
};